import { render, staticRenderFns } from "./ConnectionTypesList.vue?vue&type=template&id=31f99028&scoped=true"
import script from "./ConnectionTypesList.vue?vue&type=script&lang=js"
export * from "./ConnectionTypesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f99028",
  null
  
)

export default component.exports